<template>
  <div>
    <div class="container mt-4 mb-4">
      <!-- <atras-component></atras-component> -->
      <boton-atras :nombre_ruta="'Menu'"></boton-atras>
      <div class="row">
        <div class="col-md mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
          
          <!-- ================================================================= -->
          <!-- SECCIÓN: PROCESOS VIGENTES -->
          <!-- ================================================================= -->
          <h5 class="subtitulo">Procesos Vigentes</h5>
          <div class="lineaNegra"></div>
          <div class="mt-1 mb-4 lineaNegra2"></div>
          <!-- Espacio libre para cuando agregues los enlaces de los procesos actuales -->
          <p class="text-muted small pl-2 mb-5">Por el momento no se encuentran procesos vigentes.</p>

          <!-- ================================================================= -->
          <!-- SECCIÓN: HISTÓRICO DE PROCESOS CONCLUIDOS -->
          <!-- ================================================================= -->
          <h5 class="subtitulo">Histórico de Procesos Concluidos</h5>
          <div class="lineaNegra mb-4"></div>

          <!-- SUBPROCESO: Proceso Competitivo 01 Bis/2025 -->
          <h6 class="subtitulo">Proceso Competitivo 01 Bis/2025 </h6>
          <div class="lineaNegra"></div>
          <div class="mt-1 mb-2 lineaNegra2"></div>
          
          <a :href="urlServe+'rendicion-ctas/proceso-competi/1-Bases-LP-01Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/2-Anexo-ABis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo A </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/3-Anexos-Anexo-A.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Anexos al Anexo A</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/4-Bases-LP-Anexo-B.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo B</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/5-Bases-LP-Anexo-C.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo C</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/6-Bases-LP-Anexo-D.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo D</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/7-Anexos-Anexo-D.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Anexos al Anexo D</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/8-Convocatoria-LP-01-Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Convocatoria de Licitación Pública</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Nota-LP-01-Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Nota Informativa al Proceso de Licitación Pública No. 01Bis/2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Acta-JA-Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Acta de la Junta de Aclaraciones de fecha 13 de Agosto de 2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Nota-A-PLP.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Nota Aclaratoria al Proceso de Licitación Pública No. 01 Bis/2025, de fecha 26 de agosto de 2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Acta-Apertura-Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Acta de Apertura de Ofertas</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Acta-Fallo-Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Acta de Fallo</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Anexo-A.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Anexo A de los Lineamientos de la Metodología para el Cálculo del Menor Costo Financiero y de los Procesos Competitivos de los Financiamientos y Obligaciones a contratar por parte de las Entidades Federativas, los Municipios y sus Entes Públicos </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>

          <!-- SUBPROCESO: Proceso Competitivo 01 Bis/2025 - Versión Final -->
          <h6 class="subtitulo mt-4">Proceso Competitivo 01 Bis/2025 - Versión Final</h6>
          <div class="lineaNegra"></div>
          <div class="mt-1 mb-2 lineaNegra2"></div>
          
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/1-Bases-LP-01Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/2-Anexo-ABis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo A </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/3-Anexos-Anexo-A.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Anexos al Anexo A</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/4-Bases-LP-Anexo-B.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo B</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/5-Bases-LP-Anexo-C.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo C</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/6-Bases-LP-Anexo-D.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo D</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/7-Anexos-Anexo-D.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Anexos al Anexo D</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/VF/8-Convocatoria-LP-01-Bis.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Convocatoria de Licitación Pública</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>

          <!-- SUBPROCESO: Proceso Competitivo 2025 (Cancelado) -->
          <h6 class="subtitulo mt-4">Proceso Competitivo 2025 (Cancelado)</h6>
          <div class="lineaNegra"></div>
          <div class="mt-1 mb-2 lineaNegra2"></div>
          
          <a :href="urlServe+'rendicion-ctas/proceso-competi/1-Bases-LP.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/2-Anexo-A.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Bases de Licitación Pública - Anexo A</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/3-Anexo-B.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo B </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/4-Anexo-C.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo C </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/5-Anexo-D.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Bases de Licitación Pública - Anexo D </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/6-Convocatoria.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Convocatoria de Licitación Pública 01/2025, Refinanciamiento de la Deuda Pública para el Estado de Chiapas</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/7-Nota-Informativa.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Nota Informativa al Proceso de Licitación Pública No. 01/2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/9-Nota-Informativa.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Nota Informativa al Proceso de Licitación Pública No. 01/2025, de fecha 30 de junio 2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/10-Nota-Informativa.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Nota Informativa al Proceso de Licitación Pública No. 01/2025, de fecha 04 de julio 2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/8-Acta-Junta.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Acta de Junta de Aclaraciones</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>

          <!-- SUBPROCESO: Proceso Competitivo 02/2025 -->
          <h6 class="subtitulo mt-4">Proceso Competitivo 02/2025</h6>
          <div class="lineaNegra"></div>
          <div class="mt-1 mb-2 lineaNegra2"></div>
          
          <a :href="urlServe+'rendicion-ctas/proceso-competi/1-Condiciones-Generales.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Condiciones Generales de Convocatoria Proceso de Licitación  </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/2-Convocatoria.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Convocatoria Proceso Competitivo y Licitatorio 02-2025</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Anexo-1-Tabla.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5>Anexo 1. Tabla de Amortización</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Anexo-2-Modelo.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Anexo 2. Modelo de Contrato de Crédito</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Anexo-3-Proyecto.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Anexo 3. Proyecto de Fideicomiso Maestro</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Anexo-4-Formato.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Anexo 4. Formato de Oferta</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Lineamientos-Junta.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Lineamientos para el desahogo de la junta de aclaraciones</h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>     
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Acta-Junta.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Acta de la junta de aclaraciones </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>  
          <a :href="urlServe+'rendicion-ctas/proceso-competi/Modif-Convoc.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Modificación a la Convocatoria </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a>  
          <a :href="urlServe+'rendicion-ctas/proceso-competi/2da-Modif-Convoc.pdf'" target="_blank">
            <div class="mb-2">
              <div class="title_document" style="display:flex; justify-content:space-between;">
                <div class="col-8">
                  <h5> Segunda Modificación a la Convocatoria </h5>
                </div>
                <div class="col-3">
                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                </div>
              </div>
            </div>
          </a> 
<a :href="urlServe+'rendicion-ctas/proceso-competi/Acta-Ofertas.pdf'" target="_blank">
                      <div class="mb-2">
                          <div class="title_document" style="display:flex; justify-content:space-between;">
                              <div class="col-8">
                                  <h5> Acta de Apertura de Ofertas </h5>
                              </div>
                              <div class="col-3">
                                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                              </div>
                          </div>
                      </div>
                    </a>  
                    <a :href="urlServe+'rendicion-ctas/proceso-competi/Acta-Fallo.pdf'" target="_blank">
                      <div class="mb-2">
                          <div class="title_document" style="display:flex; justify-content:space-between;">
                              <div class="col-8">
                                  <h5> Acta de Fallo</h5>
                              </div>
                              <div class="col-3">
                                  <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                              </div>
                          </div>
                      </div>
                    </a>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
  import mapFun from '@/common/map-fn-types.js';
  import RendicionDeCuentas from "@/services/rendicionDeCuentas/rendicionDeCuentas.js";
  const _serviciosRendicionC = new RendicionDeCuentas();
  import cardsArray from '../../components/cardsArray.vue';
  import cardsMenu from '../../components/cardsMenu.vue';
  import botonAtras from './../button-atras'
  import DateFormat from "@/mixins/dateFormatMixin.js";

  export default {
    components: { cardsMenu, cardsArray, botonAtras},
    data() {
          return {
              data: [],
              error: '', // Maneja mensajes de error
              loading: true, // Indicador de carga
              fecha_actualizacion:''
          };
      },
      async created() {
          await this.getMenuRendicionCuentas();
      },
      mixins: [DateFormat],
      methods: {
        routeo(n){
            switch(n) {
              case 1: return "Presupuesto-de-Egresos";
              case 2: return "Finanzas-publicas";
              case 3: return "Gestion-financiera" //  /Gestion-financiera;
              case 4: return "Recursos-a-Municipios"
              case 5: return "Estrategico-institucional-org-pub"
              case 6: return "Cuentas-Publicas"; //Cuentas-Publicas
              case 7: return "Trimestral-publicas"; //Trimestral-publicas
              case 8: return "Presup-egres-org-pub";
              default: break;
            }
          },
          /*routeo(n){
            switch(n) {
              case 1: return "Presupuesto-de-Egresos";
              case 2: return "Finanzas-publicas";
              case 3: return "Gestion-financiera";
              case 4: return "Recursos-a-Municipios";
              case 5: return "Estrategico-institucional-org-pub";
              case 6: return "Cuentas-Publicas";
              case 7: return "Trimestral-publicas";
              case 8: return "Presup-egres-org-pub";
              default: break;
            }
          },*/
          async getMenuRendicionCuentas() {
              try {
                  const response = await _serviciosRendicionC.getMenuRendicionCtas(mapFun.rendicionCtasMenu);
                  this.data = response.data;
                  let fecha_texto = this.data[this.data.length - 1].fecha_actualizacion;
                  this.fecha_actualizacion = this.DateFormatText(fecha_texto);
              } catch (error) {
                  console.log('error', error.message);
              }
          }
      }
  }
  </script>
  <style scoped>
  .title_document {
      padding: .8rem 1rem;
      width: 100%;
      height: auto;
      border: 1px solid#dfdfdf ;
      border-radius: 5px;
      border-left: 3px solid #621132;

      display: flex;
      justify-content: space-between;
      align-items: center !important;
  }

  .title_document:hover{
      box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
  }

  .descargar{
      font-size: 0.9rem;
      color: #6c757d !important;
  }

  .subtitulo {
      font-weight: 400;
      font-size: 1.8rem;
      margin-top: 1rem;
  }
  .subtitulo2{
      font-weight: 400;
      font-size: 1.2rem;
      margin-top: .5rem;
      margin-bottom: 1rem ;
  }
  .title_document h5{
      font-size: 0.9rem;
      font-weight: 400;
      /* line-height: 20px; */
  }

  .sec_imagen{
      width:85% !important;
      background-color: #560F2C;
      /* margin-top: 3rem; */
  }

  a{
      text-decoration: none !important;
      color: #212529;
  }
  a:hover{ color:#212529 !important; }

  /* margenes de la card consulta */
  .margenes{
      display: flex;
      justify-content: flex-end;
  }
  .card-width{ width: 90%; }

  /* select */
  .form-control-lg {
      font-size: 1rem;
      border-radius: .4rem;
  }

@media only screen and (max-device-width : 900px) {
  .container{
      padding-right: 1% !important;
      padding-left: 1% !important;
  }
  .title_document{
      padding: .5rem 1rem .5rem .1rem;
      line-height: 20px;
  }

  /* margenes de la card consulta */
  .margenes{ justify-content: space-around; }
  .card-width{ width: 95%; }

  .subtitulo2{ font-size: 1rem; }

  .sec_imagen{ margin-top: 0rem; }
}

</style>
